import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import ModuleCard from "../../../components/common/card";
import { option_category_obj } from "../../../service/option";

import ImgProfile from "../../../images/common/profile.png";
import ImgDangerous from "../../../images/common/dangerous.png";
import ImgTarget from "../../../images/common/target.png";
import ImgPrivacy from "../../../images/common/privacy.png";
// import ImgSecurity from "../../../images/common/security.png";
import ImgManual from "../../../images/common/manual.png";
import ImgQa from "../../../images/common/qa.png";

export default function MemberSetting() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關" },
  ];
  const cardData = [
    {
      title: option_category_obj.setting.profile.label,
      img: ImgProfile,
      url: `/member/setting/${option_category_obj.setting.profile.value}`,
    },
    {
      title: option_category_obj.setting.dangerous.label,
      img: ImgDangerous,
      url: `/member/setting/${option_category_obj.setting.dangerous.value}`,
    },
    {
      title: option_category_obj.setting.work.label,
      img: ImgTarget,
      url: `/member/setting/${option_category_obj.setting.work.value}`,
    },
    {
      title: option_category_obj.setting.privacy.label,
      img: ImgPrivacy,
      url: `/member/setting/${option_category_obj.setting.privacy.value}`,
    },
    // {
    //   title: option_category_obj.setting.security.label,
    //   img: ImgSecurity,
    //   url: `/member/setting/${option_category_obj.setting.security.value}`,
    // },
    {
      title: option_category_obj.setting.manual.label,
      img: ImgManual,
      url: `/member/setting/${option_category_obj.setting.manual.value}`,
    },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "系統相關" }} />

      <ModuleCard data={cardData} />
    </>
  );
}
